// Whether an event already has an activity logged against it: the calendar Event's `activities` holds the activities linked
// to it (the ones its "Log activity" flow created, including from the Lead / Issue timelines). Such an event doesn't offer
// "Log activity" again.
export const hasLoggedActivity = (event) => Array.isArray(event?.activities) && event.activities.length > 0

// A canceled event did not happen, so there is nothing to log an activity for: it doesn't offer "Log activity" either.
export const isEventCanceled = (event) => event?.status === 'canceled'
